import { useMutation } from "@tanstack/react-query";
import { SubjectLabelApiService } from "./subjectlabel.api";

export const useSubjectLabelService = () => {
    // UPDATE LABEL PRINT MUTATION
    const UpdateLabelPrintMutation = useMutation({
        mutationFn: (payload: any) => SubjectLabelApiService.updateLabelPrint(payload),
    });

    const InsertReprintHistoryMutation = useMutation({
        mutationFn: (payload: any) => SubjectLabelApiService.insertHistory(payload),
    }); 

    return {
        UpdateLabelPrintMutation,
        InsertReprintHistoryMutation
    };
};